import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { jsx as _jsx } from "react/jsx-runtime";
const PLGDashboardPage = Loadable({
  loader: () => /* webpackChunkName: "plg-dashboard-page" */import('FormsUI/components/dashboard/zeroState/plg/PLGDashboardPage'),
  LoadingComponent: ({
    pastDelay
  }) => {
    return pastDelay ? /*#__PURE__*/_jsx(LoadingOverlay, {
      contextual: true
    }) : null;
  }
});
export default PLGDashboardPage;